// extracted by mini-css-extract-plugin
export var active = "_7f-a";
export var activeIndicator = "_7f-9";
export var disabled = "_7f-b";
export var fullWidth = "_7f-2";
export var lg = "_7f-7";
export var md = "_7f-6";
export var redoButtonTabGroup = "_7f-0";
export var sm = "_7f-5";
export var tabButton = "_7f-4";
export var tabButtonsContainer = "_7f-1";
export var themeDestructive = "_7f-d";
export var themeNormal = "_7f-c";
export var themeSuccess = "_7f-e";
export var xl = "_7f-8";
export var xs = "_7f-3";